import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import axios from 'axios';
import db from '../dbconn';
import {API_ROOT, IMAGE_ROOT, SUB_DOMAIN} from './../api-config';
import Modal from 'react-responsive-modal';
import fetch from "isomorphic-fetch";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
import Language from './language';

import Color from 'color';


import Swal from 'sweetalert2';


class login extends Component {


    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            open: false,
            signupRedirect: false,
            fbclick: false,
            redirect404: false,
            load: false,
            langdialog: false,
            swalButton: '',

        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {


        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });


        var dbconn = new db();

        dbconn.getAll().then(data => {


            if (localStorage.getItem("remember") == "Y") {
                if (data && data.length > 0) {

                    sessionStorage.setItem("guestFlag", "N");

                    var cartTotal = 0;
                    dbconn.getAllOrder().then(productData => {
                        productData.map((item, index) => {
                            cartTotal += ((parseFloat(item.product_price) + parseFloat(item.mod_price)) * item.product_quantity);
                        });

                        sessionStorage.setItem("cartTotal", cartTotal);

                        this.setState({redirect: true});
                    });
                }
            }
        });


    }

    fetchStoreID = () => {

        var url = API_ROOT + '/fetchstoreid?sub_domain=' + SUB_DOMAIN;

        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(storeData => {

                if (storeData.status == 1 && storeData.store_data.length > 0) {

                    document.title = "Login - " + storeData.store_data[0].store_name + " - Tria Commerce";

                    localStorage.setItem('store_id', storeData.store_data[0].store_id);
                    localStorage.setItem('store_image', storeData.store_data[0].store_image);
                    localStorage.setItem('store_primary_color', storeData.store_data[0].store_primary_color);
                    localStorage.setItem("store_language", storeData.store_data[0].store_language);
                    var color = Color(storeData.store_data[0].store_primary_color).alpha(0.6).lighten(0.6);
                    localStorage.setItem('store_light_color', color.hex());
                    localStorage.setItem('store_secondary_color', storeData.store_data[0].store_secondary_color);
                    localStorage.setItem('store_button_color', storeData.store_data[0].store_button_color);
                    localStorage.setItem('store_name', storeData.store_data[0].store_name);
                    localStorage.setItem('store_address', storeData.store_data[0].store_address);
                    localStorage.setItem('store_city', storeData.store_data[0].store_city);
                    localStorage.setItem('store_state', storeData.store_data[0].store_state);
                    localStorage.setItem('store_zip', storeData.store_data[0].store_zip);
                    localStorage.setItem('store_phone', storeData.store_data[0].store_phone);
                    localStorage.setItem('store_email', storeData.store_data[0].store_email);
                    localStorage.setItem('store_delivery_range', storeData.store_data[0].store_delivery_range);
                    localStorage.setItem('store_latitude', storeData.store_data[0].store_latitude);
                    localStorage.setItem('store_longitude', storeData.store_data[0].store_longitude);
                    localStorage.setItem('merchant_id', storeData.store_data[0].merchant_id);
                    i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
                    });
                    this.setState({load: true});


                    var primaryColor = localStorage.getItem("store_primary_color");

                    if (primaryColor != null) {
                        document.documentElement.style.setProperty('--primaryColor', primaryColor);
                    }


                    var lightColor = localStorage.getItem("store_light_color");

                    if (lightColor != null) {
                        document.documentElement.style.setProperty('--lightColor', lightColor);
                    }

                    var secondaryColor = localStorage.getItem("store_secondary_color");


                    if (secondaryColor != null) {
                        document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
                    }
                    var buttonColor = localStorage.getItem("store_button_color");

                    if (buttonColor != null) {
                        document.documentElement.style.setProperty('--buttonColor', buttonColor);
                    }

                    $('#submitButton').click(e => {

                        var customer_username = $('#userNameTxt').val();
                        var customer_password = $('#userPasswordTxt').val();
                        var rememberMe = $('#rem')

                        if (customer_username == '' ||
                            customer_username == null ||
                            customer_password == '' ||
                            customer_password == null) {

                            this.state.swalButton.fire({
                                title: i18n.t('login_validation'),
                                allowOutsideClick: false
                            });

                        } else {

                            var dbconn = new db();

                            dbconn.deleteAll();
                            dbconn.deleteAllOrder();

                            this.onOpenModal();
                            axios.post(API_ROOT + '/login', {
                                customer_username: customer_username,
                                customer_password: customer_password,
                                loginType: 'L',
                                store_id: localStorage.getItem("store_id"),
                                merchant_id: localStorage.getItem("merchant_id"),
                            })
                                .then((response) => {

                                    this.onCloseModal();

                                    if (response.data.status === 1) {


                                        var data = response.data.customer_data[0];

                                        dbconn.set({
                                            customer_id: data.customer_id,
                                            customer_token: data.userToken,
                                            customer_firstname: data.customer_firstname,
                                            customer_lastname: data.customer_lastname,
                                            customer_email: data.customer_email,
                                            customer_address: data.customer_address,
                                            customer_city: data.customer_city,
                                            customer_state: data.customer_state,
                                            customer_zipcode: data.customer_zipcode,
                                            customer_phone: data.customer_phone
                                        });

                                        sessionStorage.setItem('guestFlag', 'N');
                                        sessionStorage.setItem('cartTotal', '0.00');

                                        if ($('#rememberMe').is(":checked")) {


                                            localStorage.setItem('remember', 'Y');


                                        } else {
                                            localStorage.setItem('remember', 'N');
                                        }

                                        this.setState({redirect: true});
                                    } else {

                                        this.state.swalButton.fire(i18n.t('invalid_login'));

                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        }
                    });

                    $('#guestBtn').click(e => {

                        var dbconn = new db();

                        dbconn.deleteAll();
                        dbconn.deleteAllOrder();

                        sessionStorage.setItem('guestFlag', 'Y');
                        this.setState({redirect: true});
                    });
                    this.setState({langdialog: true});

                } else {

                    this.setState({redirect: false});
                    this.setState({redirect404: true});
                }
            });
    };

    componentDidMount() {


        var height = $(window).height();
        this.setState({windowHeight: height});

        document.title = "Login - " + localStorage.getItem("store_name") + " - Tria Commerce";

        document.getElementById("favicon").href = IMAGE_ROOT + "/images/product/" + localStorage.getItem('store_image');

        this.fetchStoreID();

    }

    componentClicked = () => {

        this.setState({fbclick: true});
    };


    fbClick = () => {


        var full = window.location.host;
        var parts = full.split('.');
        var sub = parts[0];


        var url = 'https://fb.tria.menu/facebook?subdomain=' + sub;
        var winName = 'myWindow';
        var w = '700';
        var h = '300';
        var scroll = 'yes';

        var LeftPosition = 50;
        var TopPosition = 50;
        var settings = 'height=' + h + ',width=' + w + ',top=' + TopPosition + ',left=' + LeftPosition + ',scrollbars=' + scroll + ',resizable';
        var popupWindow = window.open(url, winName, settings);
    };

    responseFacebook = (FBresponse) => {
        if (FBresponse.id != null && this.state.fbclick) {

            this.onOpenModal();
            axios.post(API_ROOT + '/login', {
                customer_fb_id: FBresponse.id,
                loginType: 'F',
                store_id: localStorage.getItem("store_id"),
                merchant_id: localStorage.getItem("merchant_id"),
            })
                .then((response) => {

                    this.onCloseModal();

                    if (response.data.status === 1) {

                        var data = response.data.customer_data[0];
                        var dbconn = new db();
                        dbconn.set({
                            customer_id: data.customer_id,
                            customer_token: data.userToken,
                            customer_firstname: data.customer_firstname,
                            customer_lastname: data.customer_lastname,
                            customer_email: data.customer_email,
                            customer_address: data.customer_address,
                            customer_city: data.customer_city,
                            customer_state: data.customer_state,
                            customer_zipcode: data.customer_zipcode,
                            customer_phone: data.customer_phone
                        });

                        sessionStorage.setItem('guestFlag', 'N');
                        this.setState({redirect: true});
                    } else {
                        sessionStorage.setItem('new_email', FBresponse.email);
                        sessionStorage.setItem('new_name', FBresponse.name);
                        sessionStorage.setItem('new_fb_id', FBresponse.id);
                        this.setState({signupRedirect: true});
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            this.setState({signupRedirect: true});
        }
    };

    render() {

        const {open} = this.state;
        const {t} = this.props;


        if (this.state.redirect) {
            return <Redirect to='/menu'/>;
        }

        if (this.state.signupRedirect) {
            return <Redirect to="/signup"/>;
        }

        if (this.state.redirect404) {
            return <Redirect to="/404"/>;
        }

        if (this.state.load) {


            return (


                <div className="mainContainer">
                    <header className="fixedHeader">
                        <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                            <h2 className="welcome-text-center"><strong>{t('welcome')} </strong></h2>
                            {/*   <input type="submit" name="submitButton topButton" id="guestBtn" value="Place Order Now"/>*/}
                        </div>
                    </header>


                    <div className="middleContent">
                        <div className="simple-box m-b-0 bkg-white">
                            <div className="logo-div">
                                <Link to="/menu">
                                    {this.state.load &&
                                    <img style={{width: "25%"}} className="center-block"
                                         src={IMAGE_ROOT + "/images/product/" + localStorage.getItem('store_image')}
                                         alt="Takecharge Diner Logo"/>
                                    }
                                </Link>
                            </div>
                            <div className="logo-div">
                                <a style={{cursor: "pointer"}} id="guestBtn">
                                    {this.state.load &&
                                    <img className="center-block logoOrder"
                                         src={"/img/" + localStorage.getItem("store_language") + "/ordernow.png"}
                                         alt=""/>
                                    }
                                </a>
                            </div>
                            <div className="form-box w-75 div-center sign_in_block">

                                <div className="form-group">
                                    <input type="text" className="form-control" id="userNameTxt" name="userNameTxt"

                                           placeholder={t('mobile_or_email')}/>
                                </div>
                                <div className="form-group">
                                    <input type="password" className="form-control" id="userPasswordTxt"
                                           name="userPasswordTxt"
                                           placeholder={t('password')}/>
                                </div>
                                <div className="form-group clear p-b-15 float_l w-100">
                                    <label className="ch_box float_l">{t('remember_me')}
                                        <input type="checkbox" id="rememberMe"/>
                                        <span className="checkmark"></span>
                                    </label>
                                    <p className="float_r"><Link to="/forgotpassword"
                                                                 style={{textDecoration: "underline"}}>{t('forgot_password')}</Link>
                                    </p>
                                </div>
                                <div className="form-group">
                                    <input type="submit" name="submitButton" id="submitButton" value={t('login')}/>
                                </div>
                                <p className="m_9">or</p>
                                <div className="form-group m_b_10">
                                    <a className="link_button btn_blue" href="#"
                                       onClick={this.fbClick}><span>{t('sign_in_fb')}</span>
                                        {/* <img
                                                src="img/signin-avtar.png">*/}</a>
                                </div>
                                <div className="form-group">
                                    <p className="text-center"><Link to="/signup"
                                                                     className="underline">{t('create_new_account')}</Link> {/*<a className="underline" id="guestBtn" name="guestBtn">Start
                                        an Order</a>*/}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="bkg_box_black line_4 sign-in-block">
                        <div className="col-md-8 col-sm-9 col-xs-12 center-block float_none">
                            <div className="bkg_box_black_inner">
                                <h1 className="text-center">{t('create_new_account')}</h1>
                                <div
                                    className="bkg-black m-b-0 p-0 col-md-10 col-sm-12 col-xs-12 center-block float_none">
                                    <div className="row">
                                        <div className="bkg_box_black_content m_l_20">
                                            <div className="col-md-3 col-sm-4 col-xs-4">
                                                <div className="row">
                                                    <Link to="/signup"
                                                          className="link_button">{t('signup')}</Link>

                                                </div>
                                            </div>
                                            <div className="col-md-8 col-sm-8 col-xs-8">
                                                <div className="row">
                                                    <p className="m-b-40 text-left m_l_10">{t('disclaimer')}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <p className="text-small text-center">{t('online_ordering_by')} Tria Commerce</p>
                        </div>
                    </div>


                    <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                           onClose={this.onCloseModal} center>
                        <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('logging')}&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                        <p style={{textAlign: 'center'}}>
                            <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                        </p>
                    </Modal>


                    <Language/>
                    <div className="clearfix"></div>
                </div>

            );
        } else {
            return null;
        }

    }
}

export default withRouter(withTranslation()(login));


// WEBPACK FOOTER //
// ./src/view_components/login.js